import {useTranslation} from "react-i18next";
import {useAtomValue} from "jotai";
import {Stack, Typography} from "@mui/material";
import {ChartSearchCard} from "./ChartSearchCard";
import {selectedFieldChartsAtom} from "../../store/selectedFieldChartsStore";
import {CHARTS_MAP} from "../../utils/chartUtils";
import {FieldResult} from "../../types/domain/fieldResult";

export interface Props {
    data: FieldResult[];
}

export const FieldOtherInsightsView: React.FC<Props> = ({data}) => {
    const {t} = useTranslation();
    const selectedFieldCharts = useAtomValue(selectedFieldChartsAtom);
    const charts = selectedFieldCharts.map((item) => CHARTS_MAP[item]);

    return (
        <Stack direction="column" gap="1.25rem">
            <ChartSearchCard />
            {charts.length === 0 && (
                <Stack
                    direction="column"
                    alignItems="center"
                    bgcolor="#F3F5FA"
                    padding="1.5rem"
                    border={1}
                    borderColor="#E9EBF1 !important"
                    minWidth="15rem"
                    gap="1.25rem"
                    flex="1"
                >
                    <Typography>{t("insights.field_other_insights.no_charts")}</Typography>
                </Stack>
            )}
            {charts.length > 0 && charts.map((chart) => <chart.component key={chart.id} data={data} />)}
        </Stack>
    );
};
